import React from 'react';
import { Link } from 'react-router-dom';
import { useTheme } from '../../../contexts/ThemeContext';
import { cn } from '../../../lib/utils';
import { ACCOUNTING_REPORT_CATALOG } from './reportCatalog';

const ReportHub: React.FC = () => {
  const { colors } = useTheme();

  return (
    <div className="space-y-8">
      {ACCOUNTING_REPORT_CATALOG.map((group) => (
        <section key={group.name}>
          <div className="mb-3">
            <h2 className={cn('text-sm font-semibold uppercase tracking-wider', colors.text)}>{group.name}</h2>
            <p className={cn('text-xs mt-0.5', colors.textMuted)}>{group.description}</p>
          </div>
          <div className="grid gap-3 sm:grid-cols-2 xl:grid-cols-3">
            {group.reports.map((report) => (
              <Link
                key={report.path}
                to={report.path}
                className={cn(
                  'group rounded-xl border p-4 transition-all',
                  colors.surface,
                  colors.border,
                  'hover:border-indigo-400/60 hover:shadow-md dark:hover:border-indigo-500/40',
                )}
              >
                <div className={cn('font-medium text-sm', colors.text, 'group-hover:text-indigo-600 dark:group-hover:text-indigo-400')}>
                  {report.name}
                </div>
                <p className={cn('mt-1.5 text-xs leading-relaxed', colors.textMuted)}>{report.description}</p>
              </Link>
            ))}
          </div>
        </section>
      ))}
    </div>
  );
};

export default ReportHub;
